let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("r0C3P")).then(() => parcelRequire('cUamx'));